import { render, staticRenderFns } from "./ExibirAlertas.vue?vue&type=template&id=4a357d25&scoped=true&"
import script from "./ExibirAlertas.vue?vue&type=script&lang=js&"
export * from "./ExibirAlertas.vue?vue&type=script&lang=js&"
import style0 from "./ExibirAlertas.vue?vue&type=style&index=0&id=4a357d25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a357d25",
  null
  
)

export default component.exports